import React from "react";
import image00 from "../icons/Apple.svg";
import image01 from "../icons/Google.png";
import image02 from "../images/Live365.webp"
import image03 from "../images/blank.webp"
import Ticker from "../ticker";

class LaMesa extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 767,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({ isMobile: window.innerWidth <= 767 });
  }

  render() {
    const { isMobile } = this.state;

    return (
      <div class="container">
        <div>
          <div class="LaMesa">
            {isMobile ? (
              <>
                <iframe
                  title="LaMesa-Playing"
                  width="300"
                  height="614"
                  frameBorder="0"
                  src="https://live365.com/embeds/v1/player/a38629?s=sm&m=light&c=mp3"
                ></iframe>
                <iframe
                  title="LaMesa-Played"
                  width="300"
                  height="614"
                  frameBorder="0"
                  src="https://live365.com/embeds/v1/played/a38629?s=sm&m=light"
                ></iframe>
              </>
            ) : (
              <>
                <iframe
                  title="LaMesa-Playing"
                  width="450"
                  height="316"
                  frameBorder="0"
                  src="https://live365.com/embeds/v1/player/a38629?s=md&m=light&c=mp3"
                ></iframe>
                <iframe
                  title="LaMesa-Played"
                  width="450"
                  height="511"
                  frameborder="0"
                  src="https://live365.com/embeds/v1/played/a38629?s=md&m=light"
                ></iframe>
              </>
            )}
          </div>
        </div>
        <div class="divider-schedule">La Mesa Schedule</div>
        <div class="container-table">
          <div class="table-responsive row">
            <caption class="schedule">
              G2 Radio Network La Mesa Weekday Broadcast Schedule
            </caption>
            <table class="table table-striped table-bordered" id="weekday">
              <thead>
                <tr>
                  <th colspan="3">
                    G2 Radio Network La Mesa Weekday Broadcast Schedule
                  </th>
                </tr>
                <tr>
                  <th>Program Name</th>
                  <th>Day</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr>
                  <td>Weather</td>
                  <td>Daily</td>
                  <td>Every 35 min.</td>
                </tr>
                <tr>
                  <td>Vintage Commercials </td>
                  <td>Daily</td>
                  <td>Every 58 min.</td>
                </tr>
                <tr>
                  <td>20 TCM, JazzTrax and Station Promos</td>
                  <td>Daily</td>
                  <td>Every 65 min.</td>
                </tr>
                <tr>
                  <td>New Promos &amp; Phone Messages</td>
                  <td>Daily</td>
                  <td>Every 70 min.</td>
                </tr>
                <tr>
                  <td>VA PSAs</td>
                  <td>Daily</td>
                  <td>Every 75 min.</td>
                </tr>
                <tr>
                  <td>FSN Bulletin News</td>
                  <td>Daily</td>
                  <td>Every 100 min.</td>
                </tr>
                <tr>
                  <td>Living Well with Pam Smith</td>
                  <td>Daily</td>
                  <td>Every 180 min.</td>
                </tr>
                <tr>
                  <td>FSN Headline News</td>
                  <td>Daily</td>
                  <td>Every 190 min.</td>
                </tr>
                <tr>
                  <td>FSN World News</td>
                  <td>Daily</td>
                  <td>Every 300 min.</td>
                </tr>
                <tr>
                  <td>National Anthem</td>
                  <td>Daily</td>
                  <td>5&#58;15 AM</td>
                </tr>
                <tr>
                  <td>Sewing Machine Miracles with Dr. Jason Gordon</td>
                  <td>Daily</td>
                  <td>5&#58;30 AM</td>
                </tr>
                <tr>
                  <td>Monthly Housekeeping</td>
                  <td>Daily</td>
                  <td>5&#58;45 AM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Daily</td>
                  <td>5&#58;50 AM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>6&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Monday - Friday </td>
                  <td>6&#58;18 AM</td>
                </tr>
                <tr>
                  <td>Integrity Moment</td>
                  <td>Monday&#44; Wednesday&#44; Friday</td>
                  <td>6&#58;20 AM</td>
                </tr>
                <tr>
                  <td> National Native News</td>
                  <td>Daily</td>
                  <td>6&#58;30 AM</td>
                </tr>
                <tr>
                  <td>Faith &amp; Finance Minute</td>
                  <td>Monday - Friday</td>
                  <td>6&#58;39 AM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Monday - Friday</td>
                  <td>6&#58;45 AM</td>
                </tr>
                <tr>
                  <td>Possibly</td>
                  <td>Monday &amp; Friday</td>
                  <td>7&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Daily Consumer Radio Report</td>
                  <td>Tuesday &amp; Thursday</td>
                  <td>7&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Samaritan Ministries Family Health Checkup</td>
                  <td>Monday - Friday</td>
                  <td>7&#58;30 AM</td>
                </tr>
                <tr>
                  <td>Daily Consumer Radio Report</td>
                  <td>Monday&#44; Wednesday&#44; Friday</td>
                  <td>7&#58;45 AM</td>
                </tr>
                <tr>
                  <td>NIH</td>
                  <td>Daily</td>
                  <td>7&#58;50 AM</td>
                </tr>
                <tr>
                  <td>News in 60 with Alan Edwards</td>
                  <td>Daily</td>
                  <td>8&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Creation Moments</td>
                  <td>Monday - Friday</td>
                  <td>8&#58;15 AM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>9&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Daily</td>
                  <td>9&#58;15 AM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Monday - Friday</td>
                  <td>9&#58;45 AM</td>
                </tr>
                <tr>
                  <td>News in 60 with Alan Edwards</td>
                  <td>Daily</td>
                  <td>10&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Faith &amp; Finance Minute</td>
                  <td>Monday - Friday</td>
                  <td>10&#58;15 AM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Monday - Friday</td>
                  <td>11&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Monday - Friday</td>
                  <td>11&#58;00 AM</td>
                </tr>
                <tr>
                  <td>theSITREP</td>
                  <td>Monday, Wednesday, Friday</td>
                  <td>11&#58;30 AM</td>
                </tr>
                <tr>
                  <td>Samaritan Ministries Family Health Checkup</td>
                  <td>Monday - Friday</td>
                  <td>11&#58;45 AM</td>
                </tr>
                <tr>
                  <td>National Native News</td>
                  <td>Monday - Friday</td>
                  <td>11&#58;45 AM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>12&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Monday - Friday</td>
                  <td>12&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Monthly Housekeeping</td>
                  <td>Daily</td>
                  <td>1&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Second Street Dreams</td>
                  <td>Monday &amp; Friday</td>
                  <td>1&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Sewing Machine Miracles with Dr. Jason Gordon</td>
                  <td>Daily</td>
                  <td>1&#58;30 PM</td>
                </tr>
                <tr>
                  <td>Hope For The Heart</td>
                  <td>Monday - Friday</td>
                  <td>1&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Faith &amp; Finance Minute</td>
                  <td>Monday - Friday</td>
                  <td>2&#58;15 PM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>3&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Abide</td>
                  <td>Tuesday</td>
                  <td>3&#58;00 PM</td>
                </tr>
                <tr>
                  <td>David Rives Ministries</td>
                  <td>Daily</td>
                  <td>3&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Samaritan Ministries Family Health Checkup</td>
                  <td>Monday - Friday</td>
                  <td>3&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Monday - Friday</td>
                  <td>3&#58;45 PM</td>
                </tr>
                <tr>
                  <td>NIH</td>
                  <td>Daily</td>
                  <td>3&#58;55 PM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Monday - Friday</td>
                  <td>4&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Drive Jams</td>
                  <td>Monday - Friday</td>
                  <td>4&#58;28 PM</td>
                </tr>
                <tr>
                  <td>Daily Consumer Radio Report</td>
                  <td>Monday&#44; Wednesday&#44; Friday</td>
                  <td>5&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Daily</td>
                  <td>5&#58;20 PM</td>
                </tr>
                <tr>
                  <td>News in 60 with Alan Edwards</td>
                  <td>Daily</td>
                  <td>5&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Possibly</td>
                  <td>Monday &amp; Friday</td>
                  <td>6&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Daily Consumer Radio Report</td>
                  <td>Tuesday &amp; Wednesday</td>
                  <td>6&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Integrity Moment</td>
                  <td>Monday&#44; Wednesday&#44; Friday</td>
                  <td>6&#58;15 PM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>6&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Faith &amp; Finance Minute</td>
                  <td>Monday - Friday</td>
                  <td>6&#58;20 PM</td>
                </tr>
                <tr>
                  <td>Tiki &amp; Lounge Music Show</td>
                  <td>Monday&#44; Wednesday&#44; Friday</td>
                  <td>6&#58;30 PM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Tuesday &amp; Thursday</td>
                  <td>6&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Humans In Public Health From Brown University</td>
                  <td>Tuesday &amp; Thursday</td>
                  <td>6&#58;58 PM</td>
                </tr>
                <tr>
                  <td>Samaritan Ministries Family Health Checkup</td>
                  <td>Monday - Friday</td>
                  <td>7&#58;10 PM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Monday - Friday</td>
                  <td>7&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Military OneSource Podcast</td>
                  <td>Monday - Friday</td>
                  <td>7&#58;30 PM</td>
                </tr>
                <tr>
                  <td>News in 60 with Alan Edwards</td>
                  <td>Daily</td>
                  <td>8&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Daily</td>
                  <td>8&#58;15 PM</td>
                </tr>
                <tr>
                  <td>NIH</td>
                  <td>Daily</td>
                  <td>8&#58;20 PM</td>
                </tr>
                <tr>
                  <td>National News</td>
                  <td>Daily</td>
                  <td>9&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Sewing Machine Miracles with Dr. Jason Gordon</td>
                  <td>Daily</td>
                  <td>9&#58;30 PM</td>
                </tr>
                <tr>
                  <td>Good News</td>
                  <td>Monday - Friday</td>
                  <td>9&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Nightly Prayer</td>
                  <td>Daily</td>
                  <td>10&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Integrity Moment</td>
                  <td>Monday - Friday</td>
                  <td>10&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Monthly Housekeeping</td>
                  <td>Daily</td>
                  <td>10&#58;30 PM</td>
                </tr>
                <tr>
                  <td>National Anthem</td>
                  <td>Daily</td>
                  <td>11&#58;00 PM</td>
                </tr>
                <tr>
                  <td>The American Radio Journal</td>
                  <td>Friday</td>
                  <td>11&#58;05 PM</td>
                </tr>

                <tr>
                  <td>National News</td>
                  <td>Monday - Friday</td>
                  <td>12&#58;00 AM</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive row">
            <caption class="schedule">
              G2 Radio Network La Mesa's Weekend Broadcast Schedule
            </caption>
            <table class="table table-striped table-bordered" id="weekend">
              <thead>
                <tr>
                  <th colspan="3">
                    G2 Radio Network La Mesa&apos;s Weekend Broadcast Schedule
                  </th>
                </tr>
                <tr>
                  <th>Program Name</th>
                  <th>Day</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr>
                  <td>Bird Note</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>6&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Good News Weekend</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>6&#58;45 AM</td>
                </tr>
                <tr>
                  <td>Good News Weekend</td>
                  <td>Sunday</td>
                  <td>9&#58;45 AM</td>
                </tr>
                <tr>
                  <td>Bill Gaither&apos;s Homecoming Radio</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>10&#58;20 AM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Sunday</td>
                  <td>11&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Sunday</td>
                  <td>11&#58;00 AM</td>
                </tr>
                <tr>
                  <td>Good News Weekend</td>
                  <td>Sunday</td>
                  <td>11&#58;10 AM</td>
                </tr>
                <tr>
                  <td>The Amazing 80s with M.G. Kelly</td>
                  <td>Saturday</td>
                  <td>12&#58;00 PM</td>
                </tr>
                <tr>
                  <td>20TCM with William Ryan III</td>
                  <td>Sunday</td>
                  <td>12&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Good News Weekend</td>
                  <td>Saturday</td>
                  <td>2&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Saturday</td>
                  <td>2&#58;15 PM</td>
                </tr>
                <tr>
                  <td>Airplay 40</td>
                  <td>Saturday</td>
                  <td>2&#58;30 PM</td>
                </tr>
                <tr>
                  <td>The Lima Charlie Show</td>
                  <td>Sunday</td>
                  <td>3&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>4&#58;00 PM</td>
                </tr>
                <tr>
                  <td>The Artist Interview</td>
                  <td> Sunday</td>
                  <td>4&#58;20 PM</td>
                </tr>
                <tr>
                  <td>Crown Money Minute</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>5&#58;20 PM</td>
                </tr>
                <tr>
                  <td>Bird Note</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>5&#58;45 PM</td>
                </tr>
                <tr>
                  <td>Vinyl Impressions</td>
                  <td>Sunday</td>
                  <td>5&#58;50 PM</td>
                </tr>
                <tr>
                  <td>JazzTrax with Mr. Art Good</td>
                  <td>Saturday</td>
                  <td>6&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Humans In Public Health From Brown University</td>
                  <td>Sunday</td>
                  <td>7&#58;00 PM</td>
                </tr>
                <tr>
                  <td>Airplay40 Rewind</td>
                  <td>Sunday</td>
                  <td>8&#58;00 PM</td>
                </tr>

                <tr>
                  <td>Good News Weekend</td>
                  <td>Saturday &amp; Sunday</td>
                  <td>10&#58;45 PM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="schedule-message">
            **Some scheduled programs/segments may play before or after the
            longer scheduled programs**
          </p>
        </div>
        <div class="divider-app">Download the Live365 App</div>

        <div class="partner-row" id="01">
          <div class="column-polarid">
            <div class="polaroid"></div>
          </div>
          <div class="column-polaroid">
            <a
              href="https://live365.com/get-radio"
              target="_blank"
              rel="noreferrer"
            >
              <div class="polaroid">
                <img
                  loading="lazy"
                  src={image02}
                  alt="Live365."
                  style={{ width: "100%" }}
                />
              </div>
            </a>
          </div>
        </div>

        <div class="partner-row" id="02">
          <div class="column-polaroid">
            <a
              href="https://apps.apple.com/us/app/live365-radio-music-talk/id1228431134"
              target="_blank"
              rel="noreferrer"
            >
              <div class="polaroid">
                <img
                  loading="lazy"
                  src={image00}
                  alt="Apple Image"
                  style={{ width: "100%" }}
                />
              </div>
            </a>
          </div>

          <div class="column-polaroid">
            <a
              href="https://play.google.com/store/apps/details?id=com.live365&hl=en"
              target="_blank"
              rel="noreferrer"
            >
              <div class="polaroid">
                <img
                  loading="lazy"
                  src={image01}
                  alt="Google Image"
                  style={{ width: "100%" }}
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
export default LaMesa;
